import { types } from 'mobx-state-tree';
import moment from 'moment';

export const DateTime = types.custom({
  name: 'DateTime',
  fromSnapshot: (v: any) => (v instanceof Date ? v : new Date(v)),
  toSnapshot: (mDate: Date) => mDate.toISOString(),
  isTargetType: (date) => date instanceof Date,
  getValidationMessage: (snapshot) => {
    if (snapshot === undefined || snapshot === null) return 'Date is empty';
    const mDate = moment(snapshot);
    if (!mDate.isValid()) {
      const message = `"${snapshot}" is not in valid date for type DateTime`;
      console.error(message);
      return message;
    }
    return '';
  },
});
